import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';

const theme = createTheme({
  menu: {
    expanded: {
      width: '220px',
    },
    shrinked: {
      width: '55px',
    },
    height: '55px',
  },
  footer: {
    height: '48px',
  },
  palette: {
    type: 'light',
    primary: {
      contrastText: '#fff',
      dark: '#303f9f',
      light: '#7986cb',
      main: '#4272d7',
    },
  },
});

function MuiTheme({ children }) {
  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
}

MuiTheme.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
};

export default MuiTheme;
